import React from 'react';
import PropTypes from 'prop-types';
import defaultArt from '../assets/images/dj_kip_art.png';
import {
  Card,
  CardContent,
  CardHeader,
  CardActionArea,
  Paper,
  Avatar,
  Badge,
  Chip,
  IconButton,
  ListItem,
  CardActions,
  Box,
} from '@mui/material';
import {
  Favorite,
  FavoriteBorder,
  Star,
  StarBorder,
} from '@mui/icons-material';

const MobileCard = ({
  handleFavoriteClick,
  handleLikeClick,
  isFav,
  showLikes,
  date,
  likes,
  goToItem,
  img,
  title,
  subtitle,
  subtitleExtra,
  chips,
  children,
  cardStyles = {},
  isTrackListItem = false,
  trackPosition,
  isTrackPlaying,
  playingArt,
  onChipClick,
  showIdTag = false,
  timeDiff = '',
}) => {
  const filteredChips = chips.filter((g) => Boolean(g));

  function handleChipClick(event, chip) {
    event.stopPropagation();
    event.preventDefault();
    onChipClick && onChipClick(chip);
  }

  return (
    <>
      <Card
        sx={{
          overflow: 'visible',
          backgroundColor: 'info.dark',
          ':hover': { backgroundColor: 'info.main' },
          ...cardStyles,
        }}
      >
        <CardHeader
          action={
            <>
              <IconButton aria-label="favorite" onClick={handleFavoriteClick}>
                {isFav ? <Star /> : <StarBorder />}
              </IconButton>
              <IconButton aria-label="favorite" onClick={handleLikeClick}>
                {showLikes ? (
                  <Badge color="primary" badgeContent={likes} max={999}>
                    <Favorite />
                  </Badge>
                ) : (
                  <FavoriteBorder />
                )}
              </IconButton>
            </>
          }
          title={
            <Box
              component="span"
              sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
            >
              {date}
              {showIdTag && timeDiff && (
                <span style={{ color: '#DEFF7B' }}>{timeDiff}</span>
              )}
            </Box>
          }
          titleTypographyProps={{ fontSize: '1rem' }}
          sx={{ paddingBottom: 0 }}
        />
        <CardActionArea onClick={goToItem}>
          {isTrackListItem ? (
            <CardHeader
              avatar={
                <Badge
                  color="primary"
                  badgeContent={`#${trackPosition}`}
                  max={999}
                  anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                  sx={{ ml: 1 }}
                >
                  {isTrackPlaying ? (
                    <Avatar
                      src={playingArt}
                      sx={{ bgcolor: 'info.main', width: 56, height: 56 }}
                    ></Avatar>
                  ) : (
                    <Avatar src={img} sx={{ width: 56, height: 56 }} />
                  )}
                </Badge>
              }
              title={title}
              subheader={
                <>
                  {subtitle} <br />
                  {subtitleExtra ? `[${subtitleExtra}]` : ''}
                </>
              }
            />
          ) : (
            <CardHeader
              avatar={
                <Avatar
                  src={img || defaultArt}
                  sx={{ width: 56, height: 56 }}
                />
              }
              title={title}
              subheader={
                <>
                  {subtitle} <br />
                  {subtitleExtra ? `[${subtitleExtra}]` : ''}
                </>
              }
              sx={{ paddingTop: '5px' }}
            />
          )}
          <CardContent sx={{ py: 0 }}>
            <Paper
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                flexWrap: 'nowrap',
                listStyle: 'none',
                p: 0,
                m: 0,
                backgroundColor: 'transparent',
                boxShadow: 'none',
                backgroundImage: 'none',
                overflow: 'hidden',
                maxWidth: '100%',
              }}
              component="ul"
            >
              {filteredChips.slice(0, 3).map((g, i) => {
                const isDateChip =
                  typeof g === 'string' &&
                  (/^\d{1,2}\/\d{1,2}\/\d{2,4}$/.test(g) ||
                    /^Liked\b|^Bought\b|^Purchased\b|^First Liked\b/.test(g));
                return (
                  <ListItem
                    key={g}
                    sx={{ width: 'unset', padding: '0 8px 8px 0' }}
                  >
                    <Chip
                      onClick={(e) => handleChipClick(e, g)}
                      color={i % 2 === 0 ? 'secondary' : 'default'}
                      label={g}
                      sx={{
                        ...(isDateChip
                          ? {}
                          : {
                              maxWidth: '120px',
                              '& .MuiChip-label': {
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              },
                            }),
                      }}
                    />
                  </ListItem>
                );
              })}
            </Paper>
          </CardContent>
        </CardActionArea>
        <CardActions sx={{ justifyContent: 'center' }}>{children}</CardActions>
      </Card>
    </>
  );
};

MobileCard.propTypes = {
  handleFavoriteClick: PropTypes.func,
  handleLikeClick: PropTypes.func,
  goToItem: PropTypes.func,
  onChipClick: PropTypes.func,
  isFav: PropTypes.bool,
  showLikes: PropTypes.bool,
  date: PropTypes.string,
  likes: PropTypes.number,
  img: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  subtitleExtra: PropTypes.string,
  chips: PropTypes.array,
  children: PropTypes.node,
  cardStyles: PropTypes.object,
  isTrackListItem: PropTypes.bool,
  trackPosition: PropTypes.number,
  isTrackPlaying: PropTypes.bool,
  playingArt: PropTypes.string,
  showIdTag: PropTypes.bool,
  timeDiff: PropTypes.string,
};

export default MobileCard;
